module.exports = __webpack_public_path__ + "4e62615430f03e2dd6794c15f704c0b5.png";